import Prescription from '../containers/prescription/Prescription';
import PrescriptionEmission from '../containers/prescription/PrescriptionEmission/PrescriptionEmission';

const routes = [
  {
    path: '/v2/prescription/:prescriptionReference/:basicAuth/lme',
    component: import('../containers/LME/LME'),
    isLazy: true,
  },
  {
    path: '/v2/prescription/:prescriptionReference/:basicAuth/apac-bpa',
    component: import('../containers/apac-bpa/ApacBpa'),
    isLazy: true,
  },
  {
    path: '/v2/prescription/:prescriptionReference/:basicAuth/safeid-configure',
    component: import('../containers/certificate/SafewebConfiguration'),
    isLazy: true,
  },
  {
    path: '/v2/prescription/:prescriptionReference/:basicAuth/vidaas-authorize',
    component: import('../containers/certificate/VidaasAuthorize'),
    isLazy: true,
  },
  {
    path: '/v2/prescription/:prescriptionReference/:basicAuth/safeid-authorize',
    component: import('../containers/certificate/SafewebAuthorize'),
    isLazy: true,
  },
  {
    path: '/v2/prescription/:prescriptionReference/:basicAuth/emission',
    component: PrescriptionEmission,
  },
  {
    path: '/v2/prescription/:prescriptionReference/:basicAuth',
    component: Prescription,
  },
];

export default routes;
